import { FinancialSituationMonthlyIncome } from '../../../../types';
export var list = [
    FinancialSituationMonthlyIncome.FROM_0_TO_2K,
    FinancialSituationMonthlyIncome.BETWEEN_2K_AND_5K,
    FinancialSituationMonthlyIncome.BETWEEN_5K_AND_8K,
    FinancialSituationMonthlyIncome.BETWEEN_8K_AND_10K,
    FinancialSituationMonthlyIncome.ABOVE_10K,
];
